import React, { useState } from 'react';
import { QlikUIContext, WidgetConfig } from 'globaleris-qlik-component';
import 'globaleris-qlik-component/dist/index.css';

import Page from '../../components/page/page';
import { useQlikContext } from '../../hooks/useQlikContext';

export const WidgetConfigurationPage = props => {
  const { isContextInitialized, context } = useQlikContext();
  const [widgetId] = useState<number>(props.location.state ? props.location.state.idElement : 337);

  return (
    <Page>
      {isContextInitialized && (
        <QlikUIContext.Provider value={context}>
          {
            <WidgetConfig
              templateElementId={widgetId}
              onEndConfiguration={() => {
                javascript: void 0;
              }}
            />
          }
        </QlikUIContext.Provider>
      )}
    </Page>
  );
};
